import Image from "next/image";
import React, { useEffect, useState } from "react";
const HomeStd = (props) => {
  const [header, setHeader] = useState("");
  let data = {
    std: "Personalized, Doctor-Backed STD Testing with Treatment",
    chlamydia: "Personalized, Doctor-Backed Chlamydia Testing with Treatment",
    gonorrhea: "Personalized, Doctor-Backed Gonorrhea Testing with Treatment",
    hiv: "Personalized, Doctor-Backed HIV Testing with Treatment",
    hepatitis: "Personalized, Doctor-Backed Hepatitis Testing with Treatment",
    herpes: "Personalized, Doctor-Backed Herpes Testing with Treatment",
    sti: "Personalized, Doctor-Backed STI Testing with Treatment",
    syphilis: "Personalized, Doctor-Backed Syphilis Testing with Treatment",
    trichomoniasis:
      "Personalized, Doctor-Backed Trichomoniasis Testing with Treatment",
    homechlamydia:
      "Personalized, Doctor-Backed At Home Chlamydia Testing with Treatment",
    homegonorrhea:
      "Personalized, Doctor-Backed At Home Gonorrhea Testing with Treatment",
    homeherpes:
      "Personalized, Doctor-Backed At Home Herpes Testing with Treatment",
    homehiv: "Personalized, Doctor-Backed At Home HIV Testing with Treatment",
    homestd: "Personalized, Doctor-Backed At Home STD Testing with Treatment",
    homesti: "Personalized, Doctor-Backed At Home STI Testing with Treatment",
    mycoplasma: "Personalized, Doctor-Backed Mycoplasma Testing with Treatment",
    chlamydianearme:
      "Personalized, Doctor-Backed Chlamydia Testing Near You with Treatment",
    herpesnearme:
      "Personalized, Doctor-Backed Herpes Testing Near You Testing with Treatment",
    hivnearme:
      "Personalized, Doctor-Backed HIV Testing Near You Testing with Treatment",
    samedaystd: "Personalized, Doctor-Backed Same Day STD Testing with Treatment",
    sexualhealth:
      "Personalized, Doctor-Backed Sexual Health Testing with Treatment",
    stdscreen: "Personalized, Doctor-Backed STD Screening with Treatment",
    stdnyc: "Personalized, Doctor-Backed STD Testing in NYC with Treatment",
    stinearme: "Personalized, Doctor-Backed STD Testing Near You with Treatment",
    stinearme:
      "Personalized, Doctor-Backed STI Testing Testing Near You with Treatment",
    allergy: "Fast, Easy, and Affordable Same Day Allergy Testing",
    food: "Fast, Easy, and Affordable Same Day 36 Food Allergy Panel Testing",
    celiac: "Fast, Easy, and Affordable Same Day Celiac Complete Testing",
    celiacnearme:
      "Fast, Easy, and Affordable Same Day Celiac Complete Testing Near You",
    allergen: "Fast, Easy, and Affordable Same Day Allergen Testing",
    cat: "Fast, Easy, and Affordable Same Day Cat Allergy Testing",
    dog: "Fast, Easy, and Affordable Same Day Dog Allergy Testing",
    pollen: "Fast, Easy, and Affordable Same Day Pollen Allergy Testing",
    gluten: "Fast, Easy, and Affordable Same Day Gluten Senstivity Testing",
    homeallergy: "Fast, Easy, and Affordable Same Day At Home Allergy Testing",
    foodnearme:
      "Fast, Easy, and Affordable Same Day 36 Food Allergy Panel Testing Near You",
    allergynearme:
      "Fast, Easy, and Affordable Same Day Allergy Testing Near You",
    mold: "Fast, Easy, and Affordable Same Day Mold Allergy Testing",
    allergynyc: "Fast, Easy, and Affordable Same Day Allergy Testing in NYC",
    seafood:
      "Fast, Easy, and Affordable Same Day Sea36 Food Allergy Panel Testing",
    travel: "Same Day COVID Test for Travel with the Fastest Results",
    international:
      "Same Day COVID Test for International Travel with the Fastest Results",
    travelnearme:
      "Same Day COVID Test for Travel Near You with the Fastest Results",
    homecovid:
      "Same Day At Home COVID Test for Travel with the Fastest Results",
    covidnyc: "Same Day COVID Test for Travel in NYC with the Fastest Results",
    pcrtravel: "Same Day PCR Test for Travel with the Fastest Results",
    pcrinternational:
      "Same Day PCR Test for International Travel with the Fastest Results",
    pcrtravelnearme:
      "Same Day PCR Test for Travel Near You with the Fastest Results",
    covidantibody: "Same Day COVID Antibody Testing with the Fastest Results",
    covidblood: "Same Day COVID Blood Testing with the Fastest Results",
    antibodynearme:
      "Same Day COVID Antibody Testing Near You with the Fastest Results",
    spikeantibody:
      "Same Day COVID Spike Antibody Testing Near You with the Fastest Results",
    antibody: "Same Day COVID Antibody Testing with the Fastest Results",
    vitdblood:
      "Fast, Easy, and Affordable Same Day Vitamin D Blood Testing with Treatment",
    vitd: "Fast, Easy, and Affordable Same Day Vitamin D Testing with Treatment",
    vit: "Fast, Easy, and Affordable Same Day Vitamin Testing with Treatment",
    inflammation:
      "Fast, Easy, and Affordable Same Day Inflammation Testing with Treatment",
    vitb12:
      "Fast, Easy, and Affordable Same Day Vitmain B12 Testing with Treatment",
    b12: "Fast, Easy, and Affordable Same Day VItamin B12 Testing with Treatment",
    vitdeficiency:
      "Fast, Easy, and Affordable Same Day Vitamin Deficiency Testing with Treatment",
    vitlevelblood:
      "Fast, Easy, and Affordable Same Day Vitamin Level Blood Testing with Treatment",
    vitb12deficiency:
      "Fast, Easy, and Affordable Same Day Vitamin B12 Deficiency Testing with Treatment",
    vitdlevel:
      "Fast, Easy, and Affordable Same Day Vitamin D Level Testing with Treatment",
    vitddeficiency:
      "Fast, Easy, and Affordable Same Day Vitamin D Deficiency Testing with Treatment",
    vitlevels:
      "Fast, Easy, and Affordable Same Day Vitamin Levels Testing with Treatment",
    chronicinflammation:
      "Fast, Easy, and Affordable Same Day Chronic Inflammation Testing with Treatment",
    vitb: "Fast, Easy, and Affordable Same Day Vitamin B Testing with Treatment",
    vitb9:
      "Fast, Easy, and Affordable Same Day Vitamin B9 Testing with Treatment",
    vitb6:
      "Fast, Easy, and Affordable Same Day Vitamin B6 Testing with Treatment",
    golate: "Fast, Easy, and Affordable Same Day Folate Testing with Treatment",
    folicacid:
      "Fast, Easy, and Affordable Same Day Folic Acid Testing with Treatment",
  };
  useEffect(() => {
    let url = window.location.href.split("?");
    let keyword = "";
    if (url.length > 1) {
      keyword = url[1];
    }
    keyword = keyword.slice(6);
    let val = "";
    try {
      val = data[keyword];
    } catch (error) {
      val = "";
    }
    setHeader(val);
  }, []);
  return (
    <>
      <div className="std-main1 gapping-div">
        <div className="container">
          <div className="row">
            <div className=" col-md-6  col-12 order-lg-custom-2">
              <div className=" std-1st-div-main">
                <div className="section-main-title text-start">
                  {props.group ? (
                    <h2>{props.group}</h2>
                  ) : (
                    <>
                      {props.dki ? (
                        <h2>
                          <span className="text-dark">
                            {props.home
                              ? "At home"
                              : "Personalized, Doctor-Backed"}
                          </span>{" "}
                          <span className="">
                            {" "}
                            {props.dki.replace(/_/g, " ")}
                          </span>{" "}
                          <span className="text-dark">with treatment</span>{" "}
                          {props.pidName ? (
                            <span className="">in {props.pidName}</span>
                          ) : (
                            <span className="">near you</span>
                          )}
                        </h2>
                      ) : (
                        <h2>
                          {header === "" ||
                          header === null ||
                          header === undefined
                            ? props.data.heading
                            : header}
                        </h2>
                      )}
                    </>
                  )}
                </div>{" "}
                <small className="text-mute std-main-subtitle">
                  <b>Book a test</b> in your home or at a nearby lab <b>in minutes</b>.
                  Receive doctor messaging, follow-ups, and <b>discounted
                  supplements</b>.
                </small>
                {/* <p className="std-text text-light-blue">
              {props.data.subHeading}
              </p> */}
                <div className="std-tags-main mt-5">
                  <div className="row">
                    {props.group == null
                      ? props.data.checked.map((element, key) => (
                          <div className="col-md-6 col-12" key={key}>
                            {props.home != null &&
                            props.dki != null &&
                            key == 0 ? (
                              <div className="std-tags-iiner">
                                {/* <span className="checkicon-color"></span> */}
                                <img src="home-1.webp"/>
                                <span className="std-span text-light-blue">
                             <b>We Come </b>to You
                            </span>
                              </div>
                            ) : (
                              <>
                                {props.dki != null && key == 1 ? (
                                  <div className="std-tags-iiner">
                                    {/* <span className="checkicon-color"></span> */}
                                    <img src={element.icon_path} />
                                    <span className="std-span text-light-blue">
                                    Results as Soon as<b> Next Day</b>
                                    </span>
                                  </div>
                                ) : (
                                  <div className="std-tags-iiner">
                                    {/* <span className="checkicon-color"></span> */}
                                    <img src={element.icon_path} />
                                    <div dangerouslySetInnerHTML={ {__html: element.title} } />
                             
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        ))
                      : null}
                    {props.group != null
                      ? props.data.checked1.map((element, key) => (
                          <div className="col-md-6 col-12" key={key}>
                            {props.home != null &&
                            props.dki != null &&
                            key == 0 ? (
                              <div className="std-tags-iiner">
                                <img src="home-1.webp"/>
                                <span className="std-span text-light-blue">
                             <b>We Come </b>to You
                            </span>
                              </div>
                            ) : (
                              <div className="std-tags-iiner">
                                <img src={element.icon_path} />
                                <div dangerouslySetInnerHTML={ {__html: element.title} } />
                             
                              </div>
                            )}
                          </div>
                        ))
                      : null}
                  </div>
                </div>
                <div className="btn-div">
                  <a
                    href="#view-tests"
                    className="btn btn-lg-secondary select-test-std"
                  >
                    Select Test
                  </a>
                </div>
                <br />
                <div className="above-fold-text">
                  <span>
                    1.{" "}
                    <small className="text-mute small-fold">
                      Same Day appointments available Monday through Saturday.
                    </small>
                  </span>
                  <br />{" "}
                  <span>
                    2.{" "}
                    <small className="text-mute small-fold">
                      Partial results available within 24 hours. Full panel may
                      take longer and results vary by test, lab, & location.
                    </small>
                  </span>
                </div>
              </div>
            </div>
            <div className=" col-md-6 col-12 p-0">
              <div className="std-div-img w-100">
                    <img
                    src="/landing/stdmain.webp"
                      className="img-fluid"
                      alt="above-fold-image"
                    />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default HomeStd;